module.exports = __webpack_public_path__ + "static/media/Formularios.919d2acb.svg";